module.exports = __webpack_public_path__ + "img/shape-4.b86d6eb4.png";